export default {
  title: 'Genre',
  male: 'Masculin',
  female: 'Féminin',
  undetermined: 'Indéterminé',
};
